const MemoLine = ({ children, testId }) => (
  <div className="rounded-[18px] border border-[#D4AF37]/20 bg-white px-4 py-3" data-testid={testId}>
    <p className="text-sm leading-7 text-[#001935]">{children}</p>
  </div>
);

export const AdvisorInvestmentMemoPanel = ({ memo, hasCapturedLead, isSending, onOpenSampleMemo, onSendMemo }) => {
  if (!memo) return null;

  return (
    <div className="rounded-[24px] border border-[#D4AF37]/25 bg-[#fffaf1] px-5 py-5 shadow-[0_14px_34px_rgba(0,25,53,0.08)]" data-testid="signature-advisor-investment-memo-panel">
      <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#8b6d16]" data-testid="signature-advisor-investment-memo-eyebrow">Investment memo generation</p>
      <h4 className="mt-2 text-xl font-semibold text-[#001935]" data-testid="signature-advisor-investment-memo-subject">{memo.subject}</h4>
      <p className="mt-2 text-sm leading-7 text-[#5f5a4e]" data-testid="signature-advisor-investment-memo-summary">{memo.summary}</p>

      <div className="mt-4 space-y-3" data-testid="signature-advisor-investment-memo-body">
        <MemoLine testId="signature-advisor-investment-memo-greeting">{memo.greeting}</MemoLine>
        {memo.body_sections?.map((section, index) => (
          <MemoLine key={`${section}-${index}`} testId={`signature-advisor-investment-memo-section-${index + 1}`}>
            {section}
          </MemoLine>
        ))}
        <MemoLine testId="signature-advisor-investment-memo-next-step">{memo.next_step}</MemoLine>
      </div>

      <div className="mt-4 flex flex-wrap gap-3" data-testid="signature-advisor-investment-memo-actions">
        <button
          className="rounded-[18px] bg-[#D4AF37] px-4 py-3 text-sm font-bold text-[#1A1A1A] transition hover:bg-[#c79f29] disabled:cursor-not-allowed disabled:opacity-60"
          data-testid="signature-advisor-investment-memo-send-button"
          disabled={isSending}
          onClick={onSendMemo}
          type="button"
        >
          {isSending ? "Sending memo..." : hasCapturedLead ? "Email my memo PDF" : "Unlock memo PDF"}
        </button>
        <button
          className="rounded-[18px] border border-[#D4AF37]/35 bg-white px-4 py-3 text-sm font-semibold text-[#8b6d16] transition hover:bg-[#fff4db]"
          data-testid="signature-advisor-investment-memo-preview-button"
          onClick={onOpenSampleMemo}
          type="button"
        >
          Preview sample memo
        </button>
      </div>
    </div>
  );
};